import React from "react";
import styles from "./OfferInput.module.scss";

type OfferBoxType = {
  title?: string;
  copy?: string;
  checked?: boolean;
  setOfferSelected: (id: string) => void;
  name: string;
  value: string;
  lastOne?: boolean;
};

const OfferBox = ({
  title,
  copy,
  checked,
  setOfferSelected,
  name,
  value,
  lastOne = false,
}: OfferBoxType) => {
  const offerClasses = `${styles.offerBox} ${
    checked && styles.offerBoxChecked
  } ${lastOne && styles.offerBoxLast}`;

  return (
    <div className={offerClasses} onClick={() => setOfferSelected(value)}>
      <div className={styles.offerBoxOption}>
        <label className={styles.customRadio}>
          <input
            type="radio"
            name={name}
            checked={checked}
            onChange={e => {
              if (e.target.checked) {
                setOfferSelected(value);
              }
            }}
            className="custom-radio-input"
          />
          <span className={styles.customRadioCheckMark}>
            {checked && <img src="/icons/radiocheckmark.svg" alt="CheckMark" />}
          </span>
        </label>
      </div>
      <div className={styles.offerBoxTextWrapper}>
        <span className={styles.offerBoxTitle}>{title}</span>
        {copy && (
          <p
            className={styles.offerBoxText}
            dangerouslySetInnerHTML={{ __html: copy }}
          />
        )}
      </div>
    </div>
  );
};

export default OfferBox;
